<template>
  <div class="dg-module-form" v-if="amReady">
    <div class="title" v-if="formHeader">{{ this.getFormTitle }}</div>
    <el-row>
      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
        <dg-text-field
            :control="control"
            :editable="editable"
            :field_span="22"
            :label_span="22"
            :translateLabel='false'
            field_mark="required"
            label="Title"
            name="title"
            placeholder="Name"
            rules="required"></dg-text-field>
      </el-col>

      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
        <dg-select-field
            :control="control"
            :editable="editable"
            :field_span="22"
            :label_span="22"
            :options="$store.state['subscription-features-package-api'].dropDownList"
            :translateLabel='false'
            :translateLabels="false"
            field_mark="required"
            label="Features Package"
            name="features_package_id"
            placeholder="Select Package"
            rules="required"></dg-select-field>
      </el-col>

      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
        <dg-text-field
            :control="control"
            :editable="editable"
            :field_span="22"
            :label_span="22"
            :translateLabel='false'
            field_mark="required"
            label="Number of Days"
            name="number_of_days"
            placeholder="14"
            rules="required"></dg-text-field>
      </el-col>

      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
      <dg-text-field
          :control="control"
          :editable="editable"
          :field_span="22"
            :label_span="22"
          :translateLabel='false'
          field_mark="required"
          label="Price"
          name="rate"
          placeholder="50"
          rules="required"></dg-text-field>
      </el-col>
    </el-row>
    <el-row>
      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
        <dg-switch
            :control="control"
            :defaultValue="enabled"
            :disabled="false"
            :field_span="22"
            :label_span="22"
            :translateLabel="false"
            field_mark="optional"
            label="Enabled"
            name="enabled"
            rules="">
          <template slot="field_note">
            <div class="mt-3 font-italic">
              Choose if this package available in the subscription page
            </div>
          </template>
        </dg-switch>
      </el-col>

      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
        <dg-switch
            :control="control"
            :defaultValue="trial"
            :disabled="false"
            :field_span="22"
            :label_span="22"
            :translateLabel="false"
            field_mark="optional"
            label="Trial"
            name="trial"
            rules="">
          <template slot="field_note">
            <div class="mt-3 font-italic">
              Choose if this package is a trial<br>
              if true, user with this package will have<br>
              limited features
            </div>
          </template>
        </dg-switch>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24" class="mt-2 border-top">
        <el-col :class="$langConfig.cssClass" :span="12" class="mt-4">
          <label class="error-field-validate-message text-capitalize"
                 v-show="!this.validData">{{ (requestErrorMessage) ? $ml.get(requestErrorMessage) : $ml.get('fields_do_not_match_the_required_criteria') }}</label>
        </el-col>
        <el-col :span="12" class="pt-3 text-right">
          <dg-confirm-button
              :loading="requestOn"
              :onConfirm="moduleDeleteAction"
              :translate="false"
              class="mr-2"
              confirmButtonType="danger"
              fieldSize="mini"
              icon="el-icon-delete"
              popIcon="el-icon-delete"
              text="remove"
              title="sure to removing this record ?"
              type="danger"
              v-if="editMode"></dg-confirm-button>

          <dg-button :click="cancelEditable" class="mr-2" fieldSize="mini" icon="el-icon-close" text="cancel"
                     type="warning" v-if="editable && editMode"></dg-button>
          <dg-button :click="changeEditable" fieldSize="mini" icon="el-icon-edit" text="edit" type="success"
                     v-if="!editable && editMode"></dg-button>

          <dg-button :click="createModule" :icon="actionButtonIcon" :loading="requestOn" :text="actionButtonLabel"
                     :translate="false"
                     :type="actionButtonType" fieldSize="mini"
                     v-if="editable"></dg-button>

          <!--<dg-confirm-button
              :icon="actionButtonIcon"
              :loading="requestOn"
              :onConfirm="createModule"
              :text="actionButtonLabel"
              :translate="false"
              :type="actionButtonType"
              fieldSize="mini"
              v-if="editable"></dg-confirm-button>-->
        </el-col>
      </el-col>
    </el-row>

  </div>
</template>

<script>

import module from './../index.js'

import {notify, notifySuccess, notifyDanger} from '@/system-services/notify.js'

import fieldController from 'devegram-vue-data-collecter-eui/src/mixins/fieldController';
import moduleForm from '@/modules-config/mixins/moduleForm.js';
import moduleFormProps from '@/modules-config/mixins/moduleFormProps.js';

export default {
  beforeMount() {this.getFormData()},
  data() {
    return {
      enabled: false,
      trial: true,
      module: {...module},
      control: this,
      amReady: false,
      requestOn: false,
      editable: !this.editMode,
      requestErrorMessage: null
    }
  },
  methods: {
    getFormData() {
      let promises = []
      promises.push(this.getEntityDropDownList().then())
      promises.push($store.dispatch('subscription-features-package-api/getDropDownList').then())
      Promise.all(promises).then((values) => {
        if (this.dataToBind) {

          let switches = [
            'trial',
            'enabled',
          ]

          for (let s in switches) {
            let val = switches[s]
            this.dataToBind[val] = (this.dataToBind[val] == 1 || this.dataToBind[val])? true : false
          }
        }
        this.amReady = true
        $vue.nextTick(() => {this.bindController()})
      })
    },
    ...$mapActions('subscription-plans-api', {
      getEntityDropDownList: 'getDropDownList',
      updateImage: 'updateImage',
      updateGallery: 'updateGallery',
      removeGalleryImage: 'removeGalleryImage'
    }),
    /* Images Methods */
    removeFromGallery (file) {
      let params = {
        id: this.dataToBind.id,
        fileId: file.id,
        parentId: file.parent_id
      }
      this.removeGalleryImage(params).then(r => {
        if (this.onEditCallback) {
          this.onEditCallback(r.data, 'gallery', false)
        }
        notifySuccess('Picture Removed')
      })
    },
    async uploadMainPicture (entityId) {
      if (this.dataModel.hasOwnProperty('picture') && this.dataModel.picture) {
        let pictureParams = {
          data: {picture: this.dataModel.picture},
          id: entityId
        }
        await this.updateImage(pictureParams).then(r => {
          notifySuccess('Picture Uploaded')
        }).catch(error => {
          notifyDanger('Picture Not Uploaded')
        })
      }
    },
    async uploadGallery (entityId) {
      if (this.dataModel.hasOwnProperty('gallery') && this.dataModel.gallery) {
        let galleryParams = {
          data: {
            gallery: this.dataModel.gallery
          },
          id: entityId
        }

        await this.updateGallery(galleryParams).then(r => {
          notifySuccess('Gallery Uploaded')
        }).catch(error => {
          notifyDanger('Gallery Not Uploaded')
        })
      }
    },
    async createModule() {
      this.validateFields().then( async result => {
        if (!result) { this.requestErrorMessage = null; return}

        this.requestOn = true
        let context = this;
        let apiMethod = (this.editMode) ? 'update' : 'create';
        let apiParams = {data: {...this.dataModel}};
        if (this.editMode) apiParams.id = this.dataToBind.id;


        /* Images Handleing */
          // removing files they are handled alone
          delete apiParams.data.picture
          delete apiParams.data.gallery

          if (apiMethod == 'update') {
            await this.uploadMainPicture(this.dataToBind.id) // Updating Picture
            await this.uploadGallery(this.dataToBind.id) // Updating Gallery
          }

        this.$store.dispatch('subscription-plans-api/' + apiMethod, apiParams).then(response => {
          let entity = response.data
          this.amReady = false
          notifySuccess((apiMethod == 'update')? 'Updated' : 'Created')

          if (apiMethod == 'create') {
            this.uploadMainPicture(entity.id) // Updating Picture
            this.uploadGallery(entity.id) // Updating Gallery
          }

          $vue.nextTick(() => {
            context.amReady = true
            if (context.editMode) {
              if (context.onEditCallback) context.onEditCallback(response.data)
            } else {
              if (context.onCreateCallback) context.onCreateCallback(response.data)
            }
          })

        }).catch(error => {
          console.log('catch error', error)
          this.validData = false
          if (error.response.data.errorMessage) {
            this.requestErrorMessage = error.response.data.errorMessage
          } else {
            this.setfieldsErrorMessage({
              fieldsErrors: error.response.data
            });
          }
        }).finally(() => {this.requestOn = false})
      })
    }
  },
  mixins: [fieldController, moduleForm, moduleFormProps],
}
</script>
